import { render, staticRenderFns } from "./floating-sidebar.vue?vue&type=template&id=62bd06e2&scoped=true"
import script from "./floating-sidebar.vue?vue&type=script&lang=js"
export * from "./floating-sidebar.vue?vue&type=script&lang=js"
import style0 from "./floating-sidebar.vue?vue&type=style&index=0&id=62bd06e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62bd06e2",
  null
  
)

export default component.exports